import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Loading, withRouter } from '../shared'
import authClient from './authClient'

// Helpful article
// https://stackoverflow.com/questions/69864165/error-privateroute-is-not-a-route-component-all-component-children-of-rou
const PrivateRoute = (props) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    authClient.initialize(() => {
      const handler = () => { setLoading(false) }
      authClient.tryLogin(props.loginPath).then(handler).catch(handler)
    })
  }, [])

  const { element, unauthedPath } = props

  if (loading) {
    return <Loading />
  }

  if (authClient.isLoggedIn()) {
    return element
  }

  return (
    <Navigate
      to={unauthedPath}
      state={{
        intendedLocation: props.router.location
      }}
    />
  )
}

export default withRouter(PrivateRoute)
